import IncidentDetails from './IncidentDetails.container';
export default IncidentDetails;
